import schedulesViewStateStore from "../../store/store";
import { IOpenShiftEntity, OpenShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('UPDATE_OPEN_SHIFTS_IN_VIEW', function (
    openShiftsInView: IOpenShiftEntity[],
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    let openShifts: ObservableMap<string, IOpenShiftEntity> = viewState ? viewState.openShiftsInView : schedulesViewStateStore().openShiftsInView;
    for (let i = 0; i < openShiftsInView.length; i++) {
        openShifts.set(openShiftsInView[i].id, OpenShiftEntity.clone(openShiftsInView[i]));
    }
});
